import { useEffect, useRef } from 'react';
import { useRouter } from 'next/router';
import { connect } from 'react-redux';
import Cookies from 'universal-cookie';
import { RED_PLANET_COOKIE_NAME } from "../../constants/app";
import { EventType } from "../../lib/google-tag-manager/constants/eventType";
import { createEvent, track } from "../../lib/google-tag-manager/gtmClient";
var TrackPageView = function TrackPageView(_ref) {
  var authenticated = _ref.authenticated;
  var routeChangesInProgress = useRef([]);
  var router = useRouter();
  var cookies = new Cookies();
  var triggerPageViewEvent = function triggerPageViewEvent(url) {
    var event = createEvent({
      type: EventType.PAGE_VIEW,
      payload: {
        qffHashId: cookies.get(RED_PLANET_COOKIE_NAME),
        pathName: url,
        isLoggedIn: authenticated
      }
    });
    track(event);
  };
  useEffect(function () {
    triggerPageViewEvent(router.asPath);
    var onRouteChangeStart = function onRouteChangeStart(url) {
      routeChangesInProgress.current.push(url);
    };
    router.events.on('routeChangeStart', onRouteChangeStart);
    var onRouteChangeComplete = function onRouteChangeComplete(url) {
      setTimeout(function () {
        // ensures only one 'page_view' event is triggered per route change
        // even when there are multiple route changes due to redirects
        if (routeChangesInProgress.current.length === 1) {
          triggerPageViewEvent(url);
        }
        routeChangesInProgress.current.pop();
      });
    };
    router.events.on('routeChangeComplete', onRouteChangeComplete);
    return function () {
      router.events.off('routeChangeStart', onRouteChangeStart);
      router.events.off('routeChangeComplete', onRouteChangeComplete);
    };
  }, [authenticated]);
  return null;
};
var mapStateToProps = function mapStateToProps(_ref2) {
  var user = _ref2.user;
  return {
    authenticated: user.authenticated
  };
};
export default connect(mapStateToProps, null)(TrackPageView);